import React, { cloneElement, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Card, CardBody, CardFooter, CardHeader } from '../Card';
import classNames from 'classnames';
//import './Modal.scss';
import { IconButton } from '@mui/material';
import { CloseIcon } from '../../../../../../../icons/CloseIcon';

const transitionMs = 350;

export const Modal = React.memo(({
	children,
	actions = [],
	hideOnBackdropClick = true,
	locked = false,
	isOpen = false,
	onClose,
	showCloseButton = true,
	title = null,
	...props
}: any) => {
	const [isVisible, setIsVisible] = useState(isOpen);
	const modalRef = useRef(null);

	useEffect(() => {
		if (isOpen) {
			setIsVisible(true);
			// noScroll.on();
		}
		return () => {
			// noScroll.off();
		}
	}, [isOpen]);

	const close = () => {
		setIsVisible(false);
		setTimeout(() => {
			onClose?.();
		}, transitionMs);
	};

	const handleBackdropClick = (ev: any) => {
		const isBackDropTarget = ev.target === ev.currentTarget;
		const isFocusOutside = !ev.currentTarget.contains(document.activeElement);
		// close only if backdrop is actually clicked
		if (isBackDropTarget && isFocusOutside && hideOnBackdropClick && !locked) {
			close();
		}
	};

	if (!isOpen) {
		return null;
	}

	return createPortal(
		<div
			className={classNames('backdrop', { isVisible })}
			onClick={handleBackdropClick}
			role="presentation"
			{...props}
		>
			<div
				className="modal"
				ref={modalRef}
				role="dialog"
				aria-labelledby="modal-title"
				aria-modal="true"
			>
				{showCloseButton && (
					<IconButton
						className="closeButton"
						color={'primary'}
						onClick={() => close()}
					>
						<CloseIcon />
					</IconButton>
				)}
				<Card noBorder shadow>
					{title && <CardHeader>{title}</CardHeader>}
					<CardBody>{children}</CardBody>
				</Card>

				{actions.length > 0 && (
					<CardFooter>
						{actions.map((child: any, i: number) =>
							cloneElement(child, {
								key: `action${i}`,
								onClick: () => {
									if (child.props?.onClick) {
										child.props?.onClick?.(close);
									} else {
										close();
									}
								},
							})
						)}
					</CardFooter>
				)}
			</div>
		</div>,
		document.body
	);
}, (p, n) => p === n);
